import { Fragment } from 'react';

import { Link } from '@betterment/samba-react';

import { ActivityClient } from '../types';

type ClientNameProps = {
  users: ActivityClient[];
};

export function ClientName({ users }: ClientNameProps) {
  const { householdId } = users[0];

  return users ? (
    <Link href={`/households/${householdId}`}>
      {users.map(user => (
        <Fragment key={user.id}>
          {user.legalFullName}
          <br />
        </Fragment>
      ))}
    </Link>
  ) : (
    ''
  );
}
